import React, { useEffect, useState } from 'react';
import { CalciteSlider } from '@esri/calcite-components-react';
import styles from './SeaLevelRise.module.scss';

const SeaLevelRise = (props) => {
  // const [sliderValue, setSliderValue] = useState(props.activeSlrValue);
  const [sliderValue, setSliderValue] = useState(0);

  const sliderChange = (event) => {
    let newSliderValue = event.target.value;
    props.toggleSeaRiseLayers(sliderValue, newSliderValue);
    setSliderValue(newSliderValue);
  }

  useEffect(() => {  }, [sliderValue]);


  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
      <label className={styles.Label}>See potential sea level rise scenarios (ft)</label>
      </div>
      <CalciteSlider onCalciteSliderChange={(event) => { sliderChange(event) }} min={0} minValue={1} max={6} ticks={6} snap={true} value={sliderValue} labelHandles={true} ></CalciteSlider>
    </div>
  );
}
export default SeaLevelRise;
